import { useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBranchStore } from '@/stores';

export const UNASSIGNED_BRANCH = '__unassigned__';

export const TableBranchSelect = ({ value, onChange }) => {
  const { branches, fetchBranches } = useBranchStore();
  useEffect(() => { fetchBranches(); }, [fetchBranches]);
  return (
    <Select value={value || 'all'} onValueChange={(v) => onChange(v === 'all' ? '' : v)}>
      <SelectTrigger className="w-52 h-9" data-testid="table-branch-select"><SelectValue placeholder="All branches" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="table-branch-all">All branches</SelectItem>
        {(branches || []).map((b) => (
          <SelectItem key={b.id} value={b.id} data-testid={`table-branch-${b.id}`}>{b.name}</SelectItem>
        ))}
        <SelectItem value={UNASSIGNED_BRANCH} data-testid="table-branch-unassigned">Unassigned (legacy)</SelectItem>
      </SelectContent>
    </Select>
  );
};
